module.exports = __webpack_public_path__ + "img/wechat-pay.4ff53d87.svg";